import React, {useEffect,} from 'react';
//import Loading from "./Loading";
import { useHistory } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import ARROW from './../assets/images/up-blue.svg'
import {getBalance} from "../redux/actions/navbar";
import {toggleSideBar} from "../redux/actions/general";
import {getVendorType} from "./../services/auth";
import { setLabActiveTile } from "../redux/actions/dashboard";

const NavBarMobile = (props) => {
    const dispatch = useDispatch();
    const {toggle_sidebar_state} = useSelector(state => state.general);
    //const [balance,setBalance] = useState(0);
    const user = JSON.parse(localStorage.getItem('user'));
    let history = useHistory();
    /*const LogOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.reload();
    }*/
    useEffect(() => {
        dispatch(getBalance());
    },[dispatch]);
    /*useEffect(() => {
        if (get_balance_success.result && get_balance_success.result === 'SUCCESS'){
            setBalance(get_balance_success.data.balance);
        }
    },[get_balance_success]);*/
    /*const getPrettyBalance = (balance) => {
        return balance.toString().replace(new RegExp(',', 'g'), '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +  " تومان "
    }*/
    const toggleSideBarMethod = () => {
        console.log(toggle_sidebar_state);
        dispatch(toggleSideBar(!toggle_sidebar_state));
    };

    const clickOnBack = () => {
        if(history.location.pathname === "/panel/dashboard") {
            dispatch(setLabActiveTile("menu_mobile_lab")) 
        } else {
            history.push('/panel/dashboard')
        }
    }
    const vendor_type = getVendorType();
    return(
        <nav className="navbar navbar-expand-lg navbar-mobile navbar-light bg-white shadow-sm" style={{position:'fixed',width:'100%',top:0, height:'60px'}}>
            <div className="container-fluid">
                {vendor_type === 'HOME_CARE' || vendor_type === 'LAB' ? (
                    <div className="navbar-mobile-lab">
                    <button className="arrow-icon-nav" onClick={() => clickOnBack()}>
                        <img src={ARROW}></img>
                    </button>
                    <a className="navbar-brand-mobile lab-center" href="#">{user.title}</a>
                    </div>
                ) : (
                    <div>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={() => toggleSideBarMethod()}
                >
                    <span className="navbar-toggler-icon"/>
                </button>
                <a className="navbar-brand-mobile" href="#">{user.title}</a>
                </div>
                )}
            </div>
            {/*<div className="top-left-holder">
                {
                    get_balance_waiting ? <Loading /> :
                        <div className="balance-holder">
                            <div className="balance-title"> مانده حساب : </div>
                            <div className="balance-value">
                                {getPrettyBalance(balance)}
                            </div>
                        </div>
                }
                <button className="btn btn-small exit-btn" onClick={() => LogOut()}>خروج</button>
            </div>*/}
        </nav>
    )
};


export default NavBarMobile;